import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { geteolOptionApi, deleteEolApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import { EolList, EolCRU, eolOptionObj } from '../components';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { PageLoader, STableLoader, Pagination } from '../../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { useDispatch, useSelector } from 'react-redux';
import { getStorage } from '../../../../shared_elements/actionCreators';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const EolHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `EOL Option`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_options", operationType: ['D'] }}>
                        <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('lease_option__label', 'Lease Option Type')}</TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('validity_start_date', 'Validity Start Date ')}</TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('validity_end_date', 'Validity  End Date ')}</TableCell>
                <TableCell sx={{ minWidth: '180px' }}> {tableSorting('notice_period_start_date', 'Notice Period Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '180px' }}> {tableSorting('notice_period_end_date', 'Notice Period End Date')}</TableCell>
                <TableCell sx={{ minWidth: '180px' }}> {tableSorting('extension_start_date', 'Extension Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '180px' }}> {tableSorting('extension_end_date', 'Extension End Date')}</TableCell>
                <TableCell sx={{ minWidth: '160px' }}> {tableSorting('extension_rent', 'Extension Rent Type')}</TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('continuous', 'Continuous')}</TableCell>
                <TableCell sx={{ minWidth: '145px' }}> {tableSorting('recurring', 'Recurring')}</TableCell>
            </TableRow>
        </TableHead>
    )
}
const EolOptions = () => {
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [eolDetails, setEolDetails] = useState({ list: [], pagination: {} });
    const [eolCRU, setEolCRU] = useState({ modal: false, data: null, mode: '' });
    const [deletEol, setDeleteEol] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse("eol_options", slug);
        geteolOptionList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'EOL Options'})
        setUploadFileProgressData({uploadedFileData});
    }, [])


    const geteolOptionList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(geteolOptionApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setEolDetails(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
       dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"eol_options"}))
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (eolCRU?.modal) {
            setEolCRU({
                ...eolCRU,
                data: {
                    ...eolCRU.data,
                    attachments: eolCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        geteolOptionList('', { per_page: eolDetails?.pagination?.per_page || 50 });
    }

    const deleteEolFn = () => {
        setLoading(true);
        const idsToDelete = deletEol?.modal && deletEol?.data?.id ? [deletEol?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteEolApi(params), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete EOL Option`, success_msg: response?.data?.message, item_ids: deletEol?.data || bulk?.ids, response: response?.data })
                    setDeleteEol({ modal: false, data: null });
                    geteolOptionList('', { per_page: eolDetails?.pagination?.per_page || 50 });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete EOL Option`, error_msg: response?.data?.message, item_ids: deletEol?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        geteolOptionList('', { ...sortQuery, per_page: eolDetails?.pagination?.per_page });
    }

    const handleUpload = async (slug, mode) => {
    setSlug({slug:slug})
      await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: "eol_options",
      slug: slug,
      query: { record_action_type: mode },
      onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments ,response}) => {
        setUploadFileProgressData({ progressRefs, attachments ,response});
      },
     onSuccess: (success_msg) => {
      enqueueSnackbar(success_msg, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
       geteolOptionList("", { per_page: eolDetails?.pagination?.per_page || 50 });
     },
     onError: (err) => {
     enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
      variant: "error",
      anchorOrigin: { vertical: "top", horizontal: "right" }
     });
      }
     });
      setSlug({})
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `EOL Option`, page_type: page_type, })
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(geteolOptionApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }

    return (
       <>
       <LeasesBasicDetails/>
        <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="terms"/>
            <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="EOL Option" type="terms"/>
                            </Grid>
                             <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                        <Grid item size={{ md: 6, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_options", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {eolDetails?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} className='btn-primary action-btn-start-icon' variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_options", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setEolCRU({ modal: true, data: eolOptionObj, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add EOL Option </Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: eolDetails?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <EolHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={eolDetails?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {eolDetails?.list?.length > 0 && eolDetails?.list?.map((item, index) => {
                                              const uploadedFileData = getApiResponse("eol_options", item?.slug);

                                        return (
                                            <EolList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onEditFn={() => setEolCRU({ modal: true, data: item, mode: 'edit' })}
                                                onView={() => setEolCRU({ modal: true, data: item, mode: 'view' })}
                                                onDeleteEolFn={() => {
                                                    setDeleteEol({ modal: true, data: item });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                            />
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                    <Paper square>
                        {!skeletonLoader && !eolDetails?.list?.length && <NoRecordFound />}
                        <Pagination
                            pagination={eolDetails?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; geteolOptionList('pageLoader', { page: pageNum, per_page: eolDetails?.pagination?.per_page || 10, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); geteolOptionList('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                        />
                    </Paper>
                </Paper>
            </div>
            </Paper>
            {eolCRU.modal &&
                <EolCRU
                    fileUpload={handleUpload}
                    eolCRU={eolCRU}
                    modeType={eolCRU?.mode}
                    getResponseBack={() => {geteolOptionList('fetch', { per_page: 50 }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onOpenAttachments={() => setAttachments({ modal: true, data: eolCRU?.data, mode:'view' })}
                    onToggleModal={() => setEolCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {attachments.modal ?
                <ShowAttachments
                    moduleName="EOL Option"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={eolCRU?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='eol_options'
                /> : null
            }
            {deletEol.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deletEol.modal}
                    title={`${bulk?.modal ? (bulk?.ids?.length === (eolDetails?.list?.length || 0) ? "Delete All EOL Options" : "Delete Selected EOL Options") : "Delete EOL Option"}`}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        if (!bulk.modal) {
                            setDeleteEol({ modal: false, data: null });
                        }
                        setBulk({ modal: false, ids: [], title: '', type: '' });
                    }}
                    onDeleteRecords={() => deleteEolFn()}
                /> : null}

            { revisionHistory.modal &&  
              <RevisionHistory 
               moduleName={"eol_options"}
               revisionHistory={revisionHistory}
               onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
              />
            }
             <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />

            {isLoading ? <PageLoader /> : null}
       </>
    )
}
export default RoleBaseAccess(EolOptions, { application: 'lease_revamp', feature: 'eol_options', operationType: ['R'], leaseNav: true });
